var _rect, _path, _circle, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZhilvMark({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 72 64",
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, "\u667A\u65C5\u4E91\u54C1\u724C\u6807\u5FD7") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 44,
    height: 56,
    rx: 10,
    fill: "#147D72"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 18.5 34 11v39H16V18.5Z",
    fill: "#FFFFFF"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28.5,
    cy: 31.5,
    r: 2,
    fill: "#18221F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29 45h27M35 53h16",
    fill: "none",
    stroke: "#147D72",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M59 14c1.2 5.4 4.2 8.4 9.6 9.6C63.2 24.8 60.2 27.8 59 33.2c-1.2-5.4-4.2-8.4-9.6-9.6C54.8 22.4 57.8 19.4 59 14Z",
    fill: "#1597F6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZhilvMark);
export default __webpack_public_path__ + "static/media/zhilv-mark.58c3ccc9db084775b36bc20ee1770efc.svg";
export { ForwardRef as ReactComponent };